export enum BasketIconName {
  Empty = 'empty',
  Sale = 'sale',
}
